<template>
    <Sidebar :is_empty="true" />
    <div class="content login-content">
        <div class="inner">

            <Header title="Forgot password" :text="text" />

            <div class="result-content" v-if="result === 'success'">
                <h2 class="success">Email Sent!</h2>
                <p>Check your email and follow the instructions to <br>reset your password</p>
                <div class="submit-wrap">
                    <Button size="40" color="dark-blue" to="/login">Sign in</Button>
                    <p><router-link to="/login">Return to Sign in</router-link></p>
                </div>
            </div>

            <div class="result-content" v-else-if="result === 'error'">
                <h2 class="error">Sorry</h2>
                <p>We can’t find an account associated with that email.<br>Please try again or try logging in using another method.</p>
                <div class="submit-wrap">
                    <Button size="40" color="dark-blue" @click.native="retry()">Retry</Button>
                    <p><router-link to="/login">Return to Sign in</router-link></p>
                </div>
            </div> 
            
            <Form v-else :schema="schema" @submit="submit" :values="values" v-slot="{ errors, success }" :class="['form-wrap', {'is-loading': is_loading}]">
                <Field type="text" k="email"  placeholder="Email address" :error_msg="errors.email" :is_success="success.email" @update="update"/>
                <div class="submit-wrap">
                    <Button size="40" color="dark-blue" type="submit">Send link</Button>
                    <p><router-link to="/login">Return to Sign in</router-link></p>
                </div>
            </Form>


            <Footer />
        </div>
    </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Field from '@/components/ui/Field.vue';
import Button from '@/components/ui/Button.vue';
import Form from '@/components/ui/Form.vue';

import Header from '@/components/login/Header.vue';
import Footer from '@/components/login/Footer.vue';
import * as yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(yup);

export default {
    name: 'rest-password',

    data() {
        return {
            is_error: false,
            error_msg: '',
            is_loading: false,
            schema: yup.object().shape({
                email: yup.string().required('The email can’t leave as blank').email('Must be a valid email'),
            }),
            values: {
                email: '',
            },
            text: 'Please enter the email address associated with your Motom Portal account and we’ll send you an email with a link to reset your password.',
            result: '',
        }
    },

    components: {
        Header,
        Footer,
        Sidebar,
        Form,
        Field,
        Button,
    },

    methods: {
        update(obj) {
            Object.keys(this.values).forEach(key => {
                if (key === obj.key) this.values[key] = obj.val;
            });
        },

        retry() {
            this.result = '';
            this.text = 'Please enter the email address associated with your Motom Portal account and we’ll send you an email with a link to reset your password.';
        },

        submit() {
            this.is_loading = true;


            this.$ajax('/forget-password/send-email', {
                method: 'post',
                data: this.values,
            }).then(res => {
                this.is_loading = false;
                this.result = 'success';
                this.text = '';
                
            }).catch(err => {
                this.is_loading = false;
                this.result = 'error';
                this.text = '';

                // if (err && err.response && err.response.data.data) {
                //     this.is_error = true;
                //     this.error_msg = err.response.data.data.message;
                //     this.$refs.form.init();
                // }

            });

            // todo ajax
            
            // if (this.values.email === 'haibo@motom.me') {
            //     this.result = 'success';
            //     this.text = '';
            // } else {
            //     this.result = 'error';
            //     this.text = '';
            // }
        },

        Logout() {
            localStorage.removeItem('access_token');
        },
    },

    mounted(){
        this.Logout();
    }

}
</script>

<style lang="scss">
    .login-content {
        display: flex;
        align-items: center;
        justify-content: center;

        .result-content {
            margin: 40px 0;
            text-align: center;
            color: var(--black-90);

            h2 {
                font: var(--font-demi-20);
                color: var(--green);
                margin-bottom: 12px;

                &.error {
                    color: var(--alert);
                }
            }
            
        }

        .form-wrap {
            &.is-loading {
                opacity: .5;
                pointer-events: none;
                
            }
        }

        .submit-wrap {
            margin: 44px 16px ;
            text-align: center;

            .ui-button {
                display: block;
                width: 180px;
                text-align: center;
                margin: 0 auto 16px;
            }

            a {
                font: var(--font-fg-12);
                color: var(--black-50);
                
                
                &:hover {
                    color: var(--dark-blue);
                }
            }
        }
    }
</style>